{
  "AGENT_BOTS": {
    "HEADER": "Боты",
    "LOADING_EDITOR": "Загрузка редактора...",
    "DESCRIPTION": "Agent Bots are like the most fabulous members of your team. They can handle the small stuff, so you can focus on the stuff that matters. Give them a try.You can manage your bots from this page or create new ones using the 'Configure new bot' button.",
    "LEARN_MORE": "Learn about agent bots",
    "GLOBAL_BOT_BADGE": "Системный",
    "AVATAR": {
      "SUCCESS_DELETE": "Аватар бота успешно удалён",
      "ERROR_DELETE": "Ошибка при удалении аватара бота, попробуйте ещё раз"
    },
    "CSML_BOT_EDITOR": {
      "NAME": {
        "LABEL": "Имя бота",
        "PLACEHOLDER": "Назовите вашего бота.",
        "ERROR": "Имя бота обязательно."
      },
      "DESCRIPTION": {
        "LABEL": "Описание бота",
        "PLACEHOLDER": "Что делает этот бот?"
      },
      "BOT_CONFIG": {
        "ERROR": "Пожалуйста, введите вашу конфигурацию бота CSML.",
        "API_ERROR": "Ваша CSML конфигурация неверна. Пожалуйста, исправьте её и повторите попытку."
      },
      "SUBMIT": "Проверить и сохранить"
    },
    "BOT_CONFIGURATION": {
      "TITLE": "Выберите бота агента",
      "DESC": "Назначить бота агента на источник. Они могут отвечать на первоначальные сообщения и передавать их агенту в случае необходимости.",
      "OPTION": "{name} ({description})",
      "SUBMIT": "Обновить",
      "DISCONNECT": "Отключить бота",
      "SUCCESS_MESSAGE": "Оператор успешно обновлен ботом.",
      "DISCONNECTED_SUCCESS_MESSAGE": "Успешное отключение робота агента.",
      "ERROR_MESSAGE": "Не удалось обновить бота агента. Пожалуйста, повторите попытку позже.",
      "DISCONNECTED_ERROR_MESSAGE": "Не удалось отключить бота агента. Пожалуйста, повторите попытку позже.",
      "SELECT_PLACEHOLDER": "Выбрать бота",
      "COUNTRY_BOTS": {
        "TITLE": "Боты по странам",
        "DESC": "Этот источник обслуживает несколько стран. Диалог попадает к боту своей страны: по магазину Kaufland, по маркетплейсу заказа Allegro, а иначе по языку, на котором пишет покупатель. Все остальные диалоги попадают к боту по умолчанию выше.",
        "COUNTRY": "Выберите страну",
        "BOT": "Выберите бота",
        "ADD": "Добавить бота для страны",
        "REMOVE": "Удалить",
        "DEFAULT_REQUIRED": "Сначала выберите бота по умолчанию. Бот страны заменяет его только для этой страны.",
        "DISCONNECT_ALL": "Отключить всех ботов"
      }
    },
    "ADD": {
      "TITLE": "Настроить нового бота",
      "CANCEL_BUTTON_TEXT": "Отменить",
      "API": {
        "SUCCESS_MESSAGE": "Бот успешно добавлен.",
        "ERROR_MESSAGE": "Не удалось добавить бота. Пожалуйста, повторите попытку позже."
      }
    },
    "LIST": {
      "404": "Бот не найден. Вы можете создать бота, нажав кнопку 'Настроить нового бота' ↗",
      "LOADING": "Получение ботов...",
      "TABLE_HEADER": {
        "DETAILS": "Информация о боте",
        "URL": "URL вебхука"
      },
      "TYPE": "Тип бота"
    },
    "DELETE": {
      "BUTTON_TEXT": "Удалить",
      "TITLE": "Удалить бота",
      "CONFIRM": {
        "TITLE": "Подтвердите удаление",
        "MESSAGE": "Вы уверены, что хотите удалить {name}?",
        "YES": "Да, удалить",
        "NO": "Нет, не удалять"
      },
      "SUBMIT": "Удалить",
      "CANCEL_BUTTON_TEXT": "Отменить",
      "DESCRIPTION": "Вы уверены, что хотите удалить этого бота? Это действие необратимо.",
      "API": {
        "SUCCESS_MESSAGE": "Бот успешно удален.",
        "ERROR_MESSAGE": "Не удалось удалить бота. Пожалуйста, повторите попытку позже."
      }
    },
    "EDIT": {
      "BUTTON_TEXT": "Редактировать",
      "LOADING": "Получение ботов...",
      "TITLE": "Редактировать бота",
      "CANCEL_BUTTON_TEXT": "Отменить",
      "API": {
        "SUCCESS_MESSAGE": "Бот успешно обновлен.",
        "ERROR_MESSAGE": "Не удалось обновить бота. Пожалуйста, повторите попытку позже."
      }
    },
    "FORM": {
      "AVATAR": {
        "LABEL": "Аватар бота"
      },
      "NAME": {
        "LABEL": "Имя бота",
        "PLACEHOLDER": "Введите имя бота"
      },
      "DESCRIPTION": {
        "LABEL": "Описание",
        "PLACEHOLDER": "Что делает этот бот?"
      },
      "WEBHOOK_URL": {
        "LABEL": "URL вебхука",
        "PLACEHOLDER": "https://example.com/webhook"
      },
      "ERRORS": {
        "NAME": "Имя бота обязательно",
        "URL": "URL вебхука обязателен",
        "VALID_URL": "Пожалуйста, введите корректный URL, начинающийся с http:// или https://"
      },
      "CANCEL": "Отменить",
      "CREATE": "Создать бота",
      "UPDATE": "Обновить бота"
    },
    "TYPES": {
      "WEBHOOK": "Webhook бот",
      "CSML": "CSML бот"
    }
  }
}
